module.exports = __webpack_public_path__ + "static/img/lysj.5c266ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/lysj.jpg
// module id = qLdk
// module chunks = 0